import {
  userRequest,
  userRequest1,
  publicRequest,
  userRequestMultipart,
} from "./http.service";
import queryString from "query-string";
import { toast } from "react-toastify";
import {
  fullPageStart,
  loadingStart,
  loadingStop,
  fullPageStop,
} from "../slice/loader.slice";
import { data } from "jquery";

// export const addClinic = async (formData, dispatch) => {
//   dispatch(fullPageStart());
//   try {
//     const response = await userRequest.post("/admin/add-clinic", formData);
//     if (response.data.status === "SUCCESS") {
//       toast.success(
//         "Clinic Added Successfully, Redirecting to Custom Form Page."
//       );
//       return response.data;
//     } else if (response.data.status === "ERROR") {
//       toast.error(response.data.message);
//     }
//   } catch (err) {
//     console.error(err, "Service failed");
//   } finally {
//     dispatch(fullPageStop());
//   }
// };

export const getAllClinic = async (param, dispatch) => {
  try {
    const response = await userRequest.get(
      `/admin/getAllUserByPage?page=${param.page}&sortBy=${param.sortBy}&rankSort=${param.sortRankBy}`
    );
    return response.data;
  } catch (err) {
    console.error(err, "Service failed");
  } finally {
  }
};

export const approveDisapproveUser = async (params, dispatch) => {
  console.log("params", params);
  try {
    // Call the API with POST method and send the payload
    const response = await userRequest.post(
      `/admin/approveDisapproveUser`, // API endpoint
      params // Payload containing approvalUsers and disapprovalUsers
    );

    // Handle the response
    if (response.status === 200) {
      console.log("API Success:", response.data);
      return response.data; // Return the API response data
    } else {
      console.error("API call failed with status:", response.status);
      return { success: false, message: "Failed to update user statuses" };
    }
  } catch (err) {
    console.error(err, "Service failed");
    return {
      success: false,
      message: "An error occurred while updating users",
    };
  }
};

export const getSsPermission = async (token) => {
  // dispatch(fullPageStart());

  try {
    const response = await userRequest.get(`/admin/getScreenshotPermission`, {
      headers: {
        "Content-Type": "application/json",
        token: `${token}`,
      },
    });
    return response.data;
  } catch (err) {
    console.error(err, "Service failed");
  } finally {
  }
};
export const getUserRequests = async (page, limit, searchTerm) => {
  try {
    const response = await userRequest.get(`user/getuserrequests`, {
      params: { page, limit, searchTerm },
    });
    console.log(response.data, "<===data.service");
    return response.data;
  } catch (error) {
    throw new Error("Failed to fetch user requests.");
  }
};

export const getAnswer = async (_id) => {
  try {
    const response = await userRequest.get(`admin/getAnswer/${_id}`, {});
    return response.data;
  } catch (error) {
    throw new Error("Failed to fetch user requests.");
  }
};

export const handleSearch = async (param, dispatch) => {
  try {
    const response = await userRequest.get(
      `/admin/getAllUserByPage?page=${param.page}&firstname=${param.firstname}&isDeactivate=${param.isDeactivate}&sortBy=${param.sortBy}&rankSort=${param.sortRankBy}`
    );
    return response.data;
  } catch (err) {
    console.error(err, "Service failed");
  } finally {
  }
};

export const handlePaginate = async (param, dispatch) => {
  try {
    const response = await userRequest.get(
      `/admin/getAllUserByPage?page=${param.page}&?firstname=${param.searchValue}`
    );
    return response.data;
  } catch (err) {
    console.error(err, "Service failed");
  } finally {
  }
};

export const toBeVerifiedPaginate = async (param, searchValue, dispatch) => {
  try {
    const response = await userRequest.get(
      `/user/listusers?page=${param}&filter=${searchValue}`
    );
    return response;
  } catch (err) {
    console.error(err, "Service failed");
  } finally {
  }
};

export const handlePaginateForConnects = async (param, dispatch, token) => {
  try {
    const response = await userRequest.get(
      `/user/getallconnects?page=${param.page}`,
      {
        headers: {
          "Content-Type": "application/json",
          token: `${token}`,
        },
      }
    );
    return response;
  } catch (err) {
    console.error(err, "Service failed");
  } finally {
  }
};

export const getPortfolio = async (param, token) => {
  try {
    const response = await userRequest.get(`/user/alluserpost/${param}`, {
      headers: {
        "Content-Type": "application/json",
        token: `${token}`,
      },
    });
    return response.data;
  } catch (err) {
    console.error(err, "Service failed");
  } finally {
  }
};

export const deleteSinglePost = async (param, dispatch) => {
  try {
    const response = await userRequest.delete(`/admin/deleteUserpost/${param}`);
    return response;
  } catch (err) {
    console.error(err, "Service failed");
  } finally {
  }
};

export const getAllChat = async (id, page, token) => {
  try {
    const response = await userRequest.get(
      `/user/getallconnects/${id}?page=${page}`,
      {
        headers: {
          "Content-Type": "application/json",
          token: `${token}`,
        },
      }
    );
    return response;
  } catch (err) {
    console.error(err, "Service failed");
  } finally {
  }
};

export const getUserDetails = async (param, token) => {
  try {
    const response = await userRequest.get(`/admin/getUserDetails/${param}`, {
      headers: {
        "Content-Type": "application/json",
        token: `${token}`,
      },
    });
    return response;
  } catch (err) {
    console.error(err, "Service failed");
  } finally {
  }
};

export const updateUserSoicalmedia = async (param, data, token) => {
  try {
    const response = await userRequest.put(
      `/admin/updateUserSoicalmedia/${param}`, // URL
      data, 
      {
        headers: {
          "Content-Type": "application/json",
          token:  `${token}`, // your auth token
        },
      }
    );
    return response.data;
  } catch (err) {
    console.error("Service failed:", err);
    throw err;
  }
};

export const GetUserChatData = async (id, el) => {
  try {
    const response = await userRequest.get(`/user/getChatHistory/${id}/${el}`);
    return response;
  } catch (err) {
    console.error(err, "Service failed");
  } finally {
  }
};

export const updatedConnectionLimit = async (data, token) => {
  try {
    const response = await userRequest.post(
      `/admin/updateConnectLimits`,
      data,
      {
        headers: {
          "Content-Type": "application/json",
          token: `${token}`,
        },
      }
    );
    return response;
  } catch (err) {
    console.error(err, "Service failed");
  } finally {
  }
};

export const getToBeVerifiedUsers = async (param, dispatch) => {
  let page = param ? param : 1;
  try {
    const response = await userRequest.get(`/user/listusers?page=${page}`);
    return response;
  } catch (err) {
    console.error(err, "Service failed");
  } finally {
  }
};

export const getAllData = async (token) => {
  try {
    const response = await userRequest.get(`admin/getAllAppContent`, {
      headers: {
        "Content-Type": "application/json",
        token: `${token}`,
      },
    });
    return response.data;
  } catch (err) {
    console.error(err, "Service failed");
  } finally {
  }
};

export const getAllContent = async (token) => {
  try {
    const response = await publicRequest.get(`admin/getallContent`, {
      // headers: {
      //   'Content-Type': 'application/json',
      //   token: `${token}`,
      // },
    });
    return response.data;
  } catch (err) {
    console.error(err, "Service failed");
  } finally {
  }
};

export const getSpecificContent = async (token, skill) => {
  console.log("skill in getSpecificContent==>", skill);
  try {
    // Perform the API call, passing the token and skill as query parameters
    const response = await publicRequest.get(`admin/getSpecificContent`, {
      params: {
        skillName: skill, // Send skill as a query parameter
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`, // Add Authorization header for token
      },
    });

    // Return the response data if the request is successful
    return response.data;
  } catch (err) {
    console.error("Error fetching specific content:", err);
    // Optionally, handle or throw error to be caught by the calling function
  }
};

export const updatePostContent = async (data, token) => {
  console.log("inside the updatePostContent");
  try {
    const response = await userRequest.put(`admin/updatePostContent`, data, {
      headers: {
        "Content-Type": "application/json",
        token: `${token}`,
      },
    });
    console.log("response==>", response);
    return response;
  } catch (err) {
    console.error(err, "Service failed");
  } finally {
  }
};

export const updateUserSkill = async (id, skills, specializations, token) => {
  console.log("inside the updateUserSkill");

  // Create the payload dynamically based on the input
  const payload = {
    skill: skills, // Dynamic skill values passed as argument
    specialization: specializations, // Dynamic specialization values passed as argument
  };

  try {
    const response = await userRequest.put(
      `/user/userForm/${id}`, // Updated URL with dynamic user ID
      payload // Sending the dynamic payload
    );

    console.log("response==>", response); // Logging the response from the API
    return response; // Returning the response
  } catch (err) {
    console.error(err, "Service failed"); // Error handling
  } finally {
    // Any necessary cleanup can be done here
  }
};

// /postContent

export const postContent = async (data, token) => {
  console.log("inside the updatePostContent");
  try {
    const response = await userRequest.post(`admin/postContent`, data, {
      headers: {
        "Content-Type": "application/json",
        token: `${token}`,
      },
    });
    console.log("response==>", response);
    return response;
  } catch (err) {
    console.error(err, "Service failed");
  } finally {
  }
};

// export const editClinic = async (param, data, dispatch) => {
//   dispatch(fullPageStart());

//   try {
//     const response = await userRequest.put(
//       `/admin/update-clinic?${queryString.stringify(param)}`,
//       data
//     );
//     if (response.data.status === "SUCCESS") {
//       return response.data;
//     }
//     if (response.data.status !== "SUCCESS") {
//       toast.error("ERROR");
//     }
//   } catch (err) {
//     console.error(err, "Service failed");
//   } finally {
//     dispatch(fullPageStop());
//   }
// };

// export const viewOneClinic = async (param, dispatch) => {
//   dispatch(fullPageStart());
//   try {
//     const response = await userRequest.get(
//       `/admin/view-clinic?${queryString.stringify(param)}`
//     );
//     return response.data;
//   } catch (err) {
//     console.error(err, "Service failed");
//   } finally {
//     dispatch(fullPageStop());
//   }
// };

// export const deleteClinic = async (id) => {
//   try {
//     const response = await userRequest.put(`/admin/delete-clinic/${id}`);
//     if (response.data.status === "SUCCESS") {
//       return response.data;
//     }
//     if (response.data.status !== "SUCCESS") {
//       toast.error("ERROR");
//     }
//   } catch (err) {
//     console.error(err, "Service failed");
//   } finally {
//   }
// };

export const changeStatus = async (id, data) => {
  try {
    const response = await userRequest.put(`/admin/editUser/${id}`, data);
    if (response.status === 200) {
      return response.data;
    }
    if (response.status !== 200) {
      toast.error("ERROR");
    }
  } catch (err) {
    console.error(err, "Service failed");
  } finally {
  }
};

export const changeStatusForVerification = async (_id, data, token) => {
  // console.log(">", _id, ">", data, ">", mobile , ">",token)
  try {
    // let data = {
    //   data : data1,
    //   mobile : mobile
    // }
    // console.log("get data ",data)
    const response = await userRequest.put(
      `/user/updatetobeverifieduser/${_id}`,
      data,
      {
        headers: {
          "Content-Type": "application/json",
          token: `${token}`,
        },
      }
    );
    if (response.status === 200) {
      return response.data;
    }
    if (response.status !== 200) {
      toast.error("ERROR");
    }
  } catch (err) {
    console.error(err, "Service failed");
  } finally {
  }
};

export const searchToBeVerifiedUser = async (param, dispatch) => {
  try {
    // let page = param ? param : 1;
    const response = await userRequest.get(
      `/user/listusers?filter=${param.email}&page=${param.page}`
    );
    return response.data;
  } catch (err) {
    console.error(err, "Service failed");
  } finally {
  }
};

export const tempAddApi = async (values) => {
  try {
    const response = await userRequest.post(`/user/temp_add_user`, values);
    return response;
  } catch (err) {
    console.error(err, "Service failed");
  } finally {
  }
};

export const forgotPassword = async (email) => {
  try {
    const response = await userRequest.post("/admin/forgotPassword", email);
    console.log(response.data, "res for forget ");
    // console.log("response==>", response.data);
    if (response.data.success == true) {
      toast.success("Mail Sent Successfully");
      return response.data;
    }
    if (response.data.success == false) {
      toast.error(response.data.message);
      return response.data;
    }
  } catch (err) {
    console.error(err, "Service failed");
  } finally {
  }
};

export const ResetPassword = async (data) => {
  try {
    const response = await userRequest.put(
      `/admin/resetPassword/${data.token}`,
      data
    );
    if (response.data.success == true) {
      toast.success("Password Reset Success");
      return response.data;
    }
    if (response.data.status !== true) {
      toast.error(response.data.message);
    }
  } catch (err) {
    console.error(err, "Service failed");
  } finally {
  }
};

export const getAllNotification = async (data, dispatch) => {
  // user specific but unseen only
  try {
    const response = await userRequest.get(`/user/notificationList/${data}`);
    return response.data;
  } catch (err) {
    console.error(err, "Service failed");
  } finally {
  }
};

export const fetchAllNotification = async (data, dispatch) => {
  // user specific but all read and unread
  try {
    const response = await userRequest.get(
      `/user/all/notificationList/${data}`
    );
    return response.data;
  } catch (err) {
    console.error(err, "Service failed");
  } finally {
  }
};

export const updatedNotification = async (data) => {
  const status = data.seen === true ? false : true;
  try {
    const response = await userRequest.post(
      `/user/notification/statusUpdate/${data.user}?notificationId=${data._id}&status=${status}`
    );
    return response;
  } catch (err) {
    console.error(err, "Service failed");
  } finally {
  }
};

export const markRead = async () => {
  try {
    const response = await publicRequest.post(`admin/read-all-notification`);
    return response;
  } catch (err) {
    console.error(err, "Service failed");
  } finally {
  }
};

export const updateSuperLike = async (id, data, token) => {
  console.log(id, "data : ", data);
  try {
    const response = await userRequest.put(
      `/admin/update/user/limits/${id}`,
      data,
      {
        headers: {
          "Content-Type": "application/json",
          token: `${token}`,
        },
      }
    );
    return response;
  } catch (err) {
    console.error(err, "Service failed");
  } finally {
  }
};

export const updateBoosts = async (id, data, token) => {
  console.log(id, "boosts data : ", data);
  try {
    const response = await userRequest.put(
      `/admin/update/user/limits/${id}`,
      data,
      {
        headers: {
          "Content-Type": "application/json",
          token: `${token}`,
        },
      }
    );
    return response;
  } catch (err) {
    console.error(err, "Service failed");
  } finally {
  }
};

export const updateRank = async (userId, data) => {
  console.log(userId, "data : ", data);
  try {
    const response = await userRequest.post(
      `/user/update-ranks-by-userId/${userId}`,
      data,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    console.log("response==>", response);

    return response;
  } catch (err) {
    console.error(err, "Service failed");
  } finally {
  }
};

export const updateTier = async (id, data, token) => {
  try {
    const response = await userRequest.put(
      `/admin/update/user/tier/${id}`,
      data,
      {
        headers: {
          "Content-Type": "application/json",
          token: `${token}`,
        },
      }
    );
    return response;
  } catch (err) {
    console.error(err, "Service failed");
  } finally {
  }
};

export const updateAppContent = async (token, id, content) => {
  try {
    const response = await userRequest.put(
      `/admin/updateAppContent/${id}`,
      { content },
      {
        headers: {
          "Content-Type": "application/json",
          token: `${token}`,
        },
      }
    );
    return response;
  } catch (err) {
    console.error(err, "Service failed");
    throw err;
  }
};

export const screenshotPermission = async (token, content) => {
  try {
    const response = await userRequest.post(
      `/admin/givescreenshotpermission`,
      { _id: content._id, screenshotPermission: content.screenshotPermission },
      {
        headers: {
          "Content-Type": "application/json",
          token: `${token}`,
        },
      }
    );
    return response;
  } catch (err) {
    console.error(err, "Service failed");
    throw err;
  }
};

export const screenshotPermissionAll = async (token, status) => {
  try {
    const response = await userRequest.post(
      `/admin/givescreenshotpermissionToAll`,
      { screenshotPermission: status },
      {
        headers: {
          "Content-Type": "application/json",
          token: `${token}`,
        },
      }
    );
    return response;
  } catch (err) {
    console.error(err, "Service failed");
    throw err;
  }
};

export const sendLink = async (token, content) => {
  console.log(content, "content");
  try {
    const response = await userRequest.post(
      `/admin/send-deeplink`,
      { userId: content.userId, linkData: content.linkData },
      {
        headers: {
          "Content-Type": "application/json",
          token: `${token}`,
        },
      }
    );
    return response;
  } catch (err) {
    console.error(err, "Service failed");
    throw err;
  }
};

export const getSkill = async (_id) => {
  try {
    const response = await userRequest.get(`admin/fetchSkill`, {});
    return response.data;
  } catch (error) {
    throw new Error("Failed to fetch user requests.");
  }
};

export const getSpecialiazation = async (_id) => {
  try {
    const response = await userRequest.get(
      `admin/fetchSpecialiazation/${_id}`,
      {}
    );
    return response.data;
  } catch (error) {
    throw new Error("Failed to fetch user requests.");
  }
};

export const getSpecialiazations = async (_id) => {
  try {
    const response = await userRequest.get(
      `admin/fetchSpecialiazations/${_id}`,
      {}
    );
    return response.data;
  } catch (error) {
    throw new Error("Failed to fetch user requests.");
  }
};

export const getTotalUsers = async () => {
  try {
    const response = await userRequest.get(`admin/getDashboardStats`);
    return response.data;
  } catch (error) {
    throw new Error("Failed to fetch user requests.");
  }
};

export const getRoomChatDetails = async (payload) => {
  try {
    const response = await userRequest.post(`admin/getRoomChatDetails`, {
      payload,
    });
    return response.data;
  } catch (error) {
    throw new Error("Failed to fetch user requests.");
  }
};

export const getTotalMatches = async () => {
  try {
    const response = await userRequest.get(`admin/getTotalMatches`);
    return response.data;
  } catch (error) {
    throw new Error("Failed to fetch user requests.");
  }
};

export const getTotalMessages = async () => {
  try {
    const response = await userRequest.get(`admin/getTotalMessages`);
    return response.data;
  } catch (error) {
    throw new Error("Failed to fetch user requests.");
  }
};

export const getMessagesBySender = async (payload) => {
  try {
    const response = await userRequest.post(`admin/getMessagesBySender`, {
      payload,
    });
    return response.data;
  } catch (error) {
    throw new Error("Failed to fetch user requests.");
  }
};

export const getConnectedUsers = async (payload) => {
  try {
    const response = await userRequest.post(`admin/getConnectedUsers`, {
      payload,
    });
    return response?.data;
  } catch (error) {
    throw new Error("Failed to fetch user requests.");
  }
};

export const getMostActiveUsers = async (params) => {
  try {
    const response = await userRequest.get("admin/getMostActiveUsers", {
      params,
    });
    return response?.data;
  } catch (error) {
    throw new Error("Failed to fetch user requests.");
  }
};

export const generateUserPdf = async (userId) => {
  try {
    console.log("🚀 Sending request to backend with userId:", userId);
    const response = await userRequest.post(
      "/admin/generate-user-pdf",
      { userId },
      { responseType: "blob" } // 👈 critical for binary
    );
    console.log("✅ Received response from server");
    return response;
  } catch (error) {
    console.error("❌ Failed to fetch user PDF:", error);
    throw new Error("Failed to fetch user requests.");
  }
};
